import React, { useMemo, useReducer } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import RouteErrorBoundary from './components/ErrorBoundary/RouteErrorBoundary';
import { ScrollToTop } from './util/ScrollToTop';
import {
  AuthProvider, UiProvider, uiReducer, initialSettings,
} from './appContext';
import './assets/vendors/style';
import './styles/wieldy.less';
import './app.less';

const App = () => {
  const [uiState, uiDispatch] = useReducer(uiReducer, initialSettings);
  const ui = useMemo(() => ({ uiState, uiDispatch }), [uiState]);

  return (
    <AuthProvider>
      <UiProvider value={ui}>
        <BrowserRouter>
          <ScrollToTop />
          {/* Inside the router, so a crash on one screen clears when the
              user navigates away from it. */}
          <RouteErrorBoundary>
            <AppRoutes />
          </RouteErrorBoundary>
        </BrowserRouter>
      </UiProvider>
    </AuthProvider>
  );
};

export default App;
